import axios from "../api/axios";
import useAuth from './useAuth';

const REFRESH_URL = '/refreshtoken'

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        const response = await axios.post(REFRESH_URL, 
        JSON.stringify({name: 'generateToken', param: {}}),
        {
            withCredentials: true
        });
        console.log(response);
        console.log(response.data);
        console.log(response.data.accessToken);
        setAuth(prev => {
            console.log(JSON.stringify(prev));
            console.log(response.data.accessToken);
            return { ...prev, accessToken: response.data.accessToken }
        });
        return response.data.accessToken;
    }
  return refresh;
}

export default useRefreshToken;